import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import MappingLanding from './MappingLanding';
import MappingWizard from './MappingWizard';

const MappingPage: React.FC = () => {
  const [showWizard, setShowWizard] = useState(false);

  return (
    <div className="max-w-[1400px] mx-auto">
      <div className="mb-6 flex items-center gap-3">
        {showWizard && (
          <button
            onClick={() => setShowWizard(false)}
            className="p-1.5 rounded-lg text-cargo-muted hover:text-cargo-text hover:bg-cargo-panel transition-colors"
            title="Back to history"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        )}
        <div>
          <h1 className="text-2xl font-bold text-cargo-text">Schema Mapping</h1>
          <p className="text-cargo-muted mt-1">
            Cargo engine generates source-to-target column mappings with confidence scores
          </p>
        </div>
      </div>

      {showWizard ? (
        <MappingWizard onClose={() => setShowWizard(false)} />
      ) : (
        <MappingLanding onNewRun={() => setShowWizard(true)} />
      )}
    </div>
  );
};

export default MappingPage;
